<template lang="pug">

md-list
    md-list-item.md-inset(
        v-for="[name, opt] of Object.entries(sett._options)"
        :key="name"
        v-if="isDisplay(name)")
        v-input(
            :value="values[name]"
            :name="opt.name"
            :type="sett._typeDefine(name)"
            :enum="opt.enum"
            :txtDescr="opt.txtDescr"
            :txtEditable="opt.txtEditable"
            :txtEnable="opt.txtEnable"
            :txtError="errors[name]"
            :isRequired="sett._isRequired(name)"
            :isEditable="sett._isEditable(name)"
            :isEnabled="sett._isEnabled(name)"
            :isPassword="opt.isPassword"
            :lengthShortMax="lengthShortMax"
            :tooltipPos="tooltipPos"
            @edited="value => update(name, value)")
</template>

<script>

import Input from '@@/input/vue/Input'

export default {
    name: 'v-settings',
    components: {
        'v-input': Input
    },
    props: {
        sett: {
            name: 'Settings',
            type: Object,
            required: true,
            txtDescr: `Settings instance for display`,
            editable: _ => false
        },
        onlyEnabled: {
            name: 'Only enabled',
            type: Boolean,
            txtDescr: `If true, only enabled options will be presented`,
            default: _ => false
        },
        onlyEditable: {
            name: 'Only editable',
            type: Boolean,
            txtDescr: `If true, only editable options will be presented`,
            default: _ => false
        },
        onlyRequired: {
            name: 'Only required',
            type: Boolean,
            txtDescr: `If true, only required options will be presented`,
            default: _ => false
        },
        lengthShortMax: {
            name: 'Length max (short)',
            type: Number,
            txtDescr: `If text is longer, input will be shown as textarea`,
            default: _ => 20
        },
        tooltipPos: {
            name: 'Tooltip position',
            type: String,
            enum: ['top', 'rigth', 'bottom', 'left', 'none'],
            txtDescr: `Position of the tooltip (if is null, will not be shown)`,
            default: _ => 'right'
        }
    },
    data() {
        return {
            values: this.sett._copy(),
            errors: {}
        }
    },
    methods: {
        isDisplay(name) {
            if(this.onlyEnabled && !this.sett._isEnabled(name))
                return false
            if(this.onlyEditable && !this.sett._isEditable(name))
                return false
            if(this.onlyRequired && !this.sett._isRequired(name))
                return false
            return true
        },
        update(name, value) {
            try {
                this.sett._set(name, value)
                this.errors[name] = undefined
            }
            catch(err) {
                const error = {}
                error[name] = err.isMessage ? err.txt : err
                this.errors = Object.assign({}, this.errors, error)

            }
            if(!this.errors[name]) {
                try{
                    this.sett._save()
                }
                catch(err) {
                    console.log(`Can't save settings. Error: `, err)
                }
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/settings/vue/Settings.vue